import React from 'react';
import { Form, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Field from 'redux-form/es/Field';
import { Button, Grid, Segment } from 'semantic-ui-react';
import { email, required } from '../../../../../../lib/FormValidators';
import { Tech3Input, Tech3Select } from '../../../../../../components/FormElements';
import { fetchProjectDataTrees } from '../../data/fileImport/dataTreesActions';
import { startSession } from '../../data/fileImport/sessionsActions';
import { createParticipant } from '../../data/fileImport/participantActions';

const addParticipantFormName = 'addParticipantForm';
const newParticipantSexOptions = [
  {
    key: 'sex_male',
    value: 'M',
    text: 'Male'
  },
  {
    key: 'sex_female',
    value: 'F',
    text: 'Female'
  }
];

class AddParticipantForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: ''
    };
  }

  getYearOfBirthOptions(range) {
    const yearOfBirthOptions = [];
    const currentYear = new Date().getFullYear();

    for (let i = 0; i < range; i++) {
      const year = currentYear - i;

      yearOfBirthOptions.push({
        key: `year_${year}`,
        value: year,
        text: year
      });
    }

    return yearOfBirthOptions;
  }

  SubmitAddParticipantForm(values) {
    const newParticipant = {
      email: values.newParticipantEmail,
      sex: values.newParticipantSex,
      birthyear: values.newParticipantYearOfBirth
    };

    this.props.dispatch(
      createParticipant(newParticipant, participant => {
        if (participant.id) {
          participant.email = newParticipant.email;
          this.props.submitAddParticipantForm(participant);
        } else {
          console.log('error');
          this.setState({
            errorMsg: 'Participant already exists'
          });
        }
      })
    );
  }

  render() {
    return (
      <Form
        className="addParticipantForm"
        onSubmit={this.props.handleSubmit(this.SubmitAddParticipantForm.bind(this))}
      >
        <Segment className="startSessionForm__participant-data data-participant-section">
          <h4 className="section-title">Add participant</h4>
          <Grid columns={16}>
            <Grid.Row>
              <Grid.Column width={16}>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      placeholder="User email"
                      name="newParticipantEmail"
                      type="email"
                      errorMsg={this.state.errorMsg}
                      component={Tech3Input}
                      validate={[required, email]}
                      onChange={() => {
                        this.setState({
                          errorMsg: ''
                        });
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      name="newParticipantYearOfBirth"
                      options={this.getYearOfBirthOptions(100)}
                      placeholder="Choose year of birth..."
                      component={Tech3Select}
                      upward={false}
                      validate={[required]}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Field
                      name="newParticipantSex"
                      options={newParticipantSexOptions}
                      placeholder="Choose sex..."
                      component={Tech3Select}
                      upward={false}
                      validate={[required]}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={4} className="cancel-btn-container">
                <Button
                  className="grey"
                  type="button"
                  onClick={this.props.cancelAddParticipantForm}
                >
                  <i className="icon-cross icon" />
                  Cancel
                </Button>
              </Grid.Column>
              <Grid.Column width={4} className="submit-btn-container">
                <Button className="green" disabled={!this.props.valid} type="submit">
                  <i className="check square outline icon" />
                  OK
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Form>
    );
  }
}

const addParticipantForm = reduxForm({
  form: addParticipantFormName,
  enableReinitialize: true
})(AddParticipantForm);

export default connect(state => ({}))(addParticipantForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/AddParticipantForm.js